export const creditCheckForm = '/creditcheck/:guid'
export const messagePage = '/creditcheck/response'



// WEBPACK FOOTER //
// ./src/constants/appRoutes.ts